export default "<h1></h1>\n"